import { useNavigate } from "react-router-dom";
import { ArrowLeft, LogOut } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { AdminPredictions } from "@/pages/admin/AdminPredictions";
import { AdminPeriods } from "@/pages/admin/AdminPeriods";
import { AdminUsers } from "@/pages/admin/AdminUsers";
import { AdminStats } from "@/pages/admin/AdminStats";
import { AdminReferral } from "@/pages/admin/AdminReferral";
import { AdminBookmakers } from "@/pages/admin/AdminBookmakers";
import { AdminGreetings } from "@/pages/admin/AdminGreetings";
import { AdminDailyBonus } from "@/pages/admin/AdminDailyBonus";
import { AdminVip } from "@/pages/admin/AdminVip";

export default function Admin() {
  const navigate = useNavigate();
  const { logout } = useAuth();

  return (
    <div className="min-h-screen bg-slate-50 tw-grain">
      <header className="sticky top-0 z-40 glass-dark border-b border-zinc-800">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 sm:px-6">
          <div className="flex items-center gap-3">
            <Logo size="text-xl" className="[&_.text-zinc-950]:text-white" />
            <span className="rounded-full bg-green-500 px-2 py-0.5 text-[10px] font-black uppercase text-zinc-950">Admin</span>
          </div>
          <div className="flex items-center gap-2">
            <Button data-testid="admin-back-to-app" onClick={() => navigate("/")} variant="ghost" size="sm" className="rounded-full text-zinc-300 hover:text-white">
              <ArrowLeft className="mr-1 h-4 w-4" /> App
            </Button>
            <Button data-testid="admin-logout" onClick={async () => { await logout(); navigate("/login"); }} variant="ghost" size="sm" className="rounded-full text-zinc-300 hover:text-white">
              <LogOut className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-6xl px-4 py-6 sm:px-6">
        <h1 className="mb-6 font-display text-4xl font-black uppercase tracking-tight text-zinc-950">Dashboard</h1>
        <Tabs defaultValue="predictions">
          <TabsList className="mb-6 flex h-auto w-full flex-wrap justify-start gap-2 bg-transparent p-0">
            <TabsTrigger data-testid="admin-tab-predictions" value="predictions" className="rounded-full border border-slate-200 bg-white px-4 py-2 font-bold data-[state=active]:bg-zinc-950 data-[state=active]:text-green-400">Pronostici</TabsTrigger>
            <TabsTrigger data-testid="admin-tab-periods" value="periods" className="rounded-full border border-slate-200 bg-white px-4 py-2 font-bold data-[state=active]:bg-zinc-950 data-[state=active]:text-green-400">Classifiche</TabsTrigger>
            <TabsTrigger data-testid="admin-tab-vip" value="vip" className="rounded-full border border-yellow-300 bg-yellow-50 px-4 py-2 font-bold text-yellow-800 data-[state=active]:bg-zinc-950 data-[state=active]:text-yellow-400">👑 VIP</TabsTrigger>
            <TabsTrigger data-testid="admin-tab-users" value="users" className="rounded-full border border-slate-200 bg-white px-4 py-2 font-bold data-[state=active]:bg-zinc-950 data-[state=active]:text-green-400">Utenti</TabsTrigger>
            <TabsTrigger data-testid="admin-tab-referral" value="referral" className="rounded-full border border-slate-200 bg-white px-4 py-2 font-bold data-[state=active]:bg-zinc-950 data-[state=active]:text-green-400">Porta un amico</TabsTrigger>
            <TabsTrigger data-testid="admin-tab-bonus" value="bonus" className="rounded-full border border-slate-200 bg-white px-4 py-2 font-bold data-[state=active]:bg-zinc-950 data-[state=active]:text-green-400">Bonus</TabsTrigger>
            <TabsTrigger data-testid="admin-tab-carota" value="carota" className="rounded-full border border-slate-200 bg-white px-4 py-2 font-bold data-[state=active]:bg-zinc-950 data-[state=active]:text-green-400">Trova la carota</TabsTrigger>
            <TabsTrigger data-testid="admin-tab-saluti" value="saluti" className="rounded-full border border-slate-200 bg-white px-4 py-2 font-bold data-[state=active]:bg-zinc-950 data-[state=active]:text-green-400">Saluti</TabsTrigger>
            <TabsTrigger data-testid="admin-tab-stats" value="stats" className="rounded-full border border-slate-200 bg-white px-4 py-2 font-bold data-[state=active]:bg-zinc-950 data-[state=active]:text-green-400">Statistiche</TabsTrigger>
          </TabsList>
          <TabsContent value="predictions"><AdminPredictions /></TabsContent>
          <TabsContent value="periods"><AdminPeriods /></TabsContent>
          <TabsContent value="vip"><AdminVip /></TabsContent>
          <TabsContent value="users"><AdminUsers /></TabsContent>
          <TabsContent value="referral"><AdminReferral /></TabsContent>
          <TabsContent value="bonus"><AdminBookmakers /></TabsContent>
          <TabsContent value="carota"><AdminDailyBonus /></TabsContent>
          <TabsContent value="saluti"><AdminGreetings /></TabsContent>
          <TabsContent value="stats"><AdminStats /></TabsContent>
        </Tabs>
      </main>
    </div>
  );
}
